import React from 'react'
import { Form } from 'antd';
import { Grid, TextField, FormControlLabel, Snackbar, MenuItem, InputLabel, Select } from '@material-ui/core';
import { LayoutTypesLookup } from "../../layoutTypes/components/lookupForm";
import Checkbox from '@material-ui/core/Checkbox';
import MySnackbarContentWrapper from "../../../components/SnackBar";

class LayoutDefinitionForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    layoutTypeId : this.props.layoutTypeId,
    checkMobile : this.props.isMobile,
    showCloseButton : this.props.showCloseButton ? this.props.showCloseButton : false,
    isHeaderHide : this.props.isHeaderHide ? this.props.isHeaderHide : false,
    isVideo : this.props.isVideo ? this.props.isVideo : false,
    isFullImage: this.props.isFullImage ? this.props.isFullImage : false,
    isFullAnchor: this.props.isFullAnchor ? this.props.isFullAnchor : false,
    tag: this.props.tag,
    snackOpen : false,
    snackType: "info",
    snackMessage: "Action executing...",
    indexType: this.props.indexType || "StaticPlace",
    insertion: this.props.insertion || "After"
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open,type,message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const variables = { 
          id: this.props.id,
          title: values.title,
          tag: this.state.tag,
          adWidth: parseFloat(values.adWidth),
          adHeight: parseFloat(values.adHeight),
          divElementName: values.divElementName,
          layoutTypeId: this.state.layoutTypeId,
          isMobile: this.state.checkMobile ? Boolean(this.state.checkMobile) : false,
          showCloseButton: this.state.showCloseButton ? Boolean(this.state.showCloseButton) : false,
          isHeaderHide: this.state.isHeaderHide ? Boolean(this.state.isHeaderHide) : false,
          isVideo: this.state.isVideo ? Boolean(this.state.isVideo) : false,
          isFullImage: this.state.isFullImage ? Boolean(this.state.isFullImage) : false,
          isFullAnchor: this.state.isFullAnchor ? Boolean(this.state.isFullAnchor) : false,
          customStyle: values.customStyle,
          imageSizesOverride: values.imageSizesOverride,
          insertion: this.state.insertion
      };
      this.state.indexType ===  "StaticPlace" ? variables.tagIndex = parseFloat(values.indexValue) : variables.dynamicPlace = parseFloat(values.indexValue);
        this.props.query_f({
          variables
        }).then(result =>{
            this.setStateValues(true,"success","Action executed with success!");
            this.props.form.resetFields();
            if(this.props.onCancel){
              this.props.onCancel();
            }
            localStorage.setItem('adireto-drawer-open', false);
          }, error=>{
            this.setStateValues(true,"error","Action executed with error!");          
          });
        }
        else{
          this.setStateValues(true,"error","Form validation failed!");  
        }
      });
    }

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  myChange = (value) => { 
    this.setState({ layoutTypeId: value });
  };

  handleChangeCheckBox = (event) => {
    this.setState({ checkMobile: event.target.checked });
  };
  
  handleChangeIsHeaderHide = (event) => {
    this.setState({ isHeaderHide: event.target.checked });
  };
  
  handleChangeIsVideo = (event) => {
    this.setState({ isVideo: event.target.checked });
  };
  
  handleChangeIsFullImage = (event) => {
    this.setState({ isFullImage: event.target.checked });
  };

  handleChangeIsFullAnchor = (event) => {
    this.setState({ isFullAnchor: event.target.checked });
  };

  handleChangeShowCloseButton = (event) => {
    this.setState({ showCloseButton: event.target.checked });
  };
  
  handleChangeTag = (value) => { 
    if(value && value.target && value.target.value){
    this.setState({ tag: value.target.value });
    }
  };

  handleChangeIndex = (value) => {
    if(value && value.target && value.target.value){
    this.setState({ indexType: value.target.value });
    }
  };

  handleChangeInsertion = (value) => {
    if(value && value.target && value.target.value){
    this.setState({ insertion: value.target.value });
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const myForm = this.props;
    const layoutTypeId = { layoutTypeId: this.state.layoutTypeId };
    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
          <MySnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage}/>
        </Snackbar>
      <Grid container spacing={0}>
      <Grid item xs={12}>
        {getFieldDecorator('title', { initialValue: (this.props.title || ''), rules: [{ required: true }],})(
          <TextField id="title" label="Title" color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }} placeholder="" />
        )}
      </Grid>      
      <Grid item xs={6}>
      <InputLabel style={{ fontSize : 12, marginTop: 15 }}>Tag</InputLabel>
          <Select fullWidth id="tag"
            labelId="select-settings-tag"
            onChange={this.handleChangeTag} value={this.state.tag}
          >
            <MenuItem value="ANCHOR" key="ANCHOR">ANCHOR</MenuItem>
            <MenuItem value="IMG" key="IMG">IMG</MenuItem>
            <MenuItem value="SKYSCRAPER" key="SKYSCRAPER">SKYSCRAPER</MenuItem>
            <MenuItem value="P" key="P">P</MenuItem>
            <MenuItem value="UL" key="UL">UL</MenuItem>
            <MenuItem value="ARTICLE" key="ARTICLE">ARTICLE</MenuItem>
            <MenuItem value="HEADER" key="HEADER">HEADER</MenuItem>
            <MenuItem value="FOOTER" key="FOOTER">FOOTER</MenuItem>
            <MenuItem value="NAV" key="NAV">NAV</MenuItem>
            <MenuItem value="ANCHOR_SIDEBAR" key="ANCHOR_SIDEBAR">ANCHOR SIDEBAR</MenuItem>
            <MenuItem value="VIDEO" key="VIDEO">VIDEO</MenuItem>
            <MenuItem value="VALIDATION" key="VALIDATION">VALIDATION</MenuItem>  
          </Select>
      </Grid>
      <Grid item xs={6}>
        <LayoutTypesLookup form={myForm} layoutTypeId={layoutTypeId} onChange={this.myChange}/>
      </Grid>

      <Grid item xs={3}>
        <InputLabel style={{ fontSize: 12,  marginTop: 14, marginBottom: 3 }}>Index Type</InputLabel>
          <Select fullWidth id="indexType"
            labelId="select-settings-indexType"
            onChange={this.handleChangeIndex} 
            value={this.state.indexType === "StaticPlace" ? "StaticPlace" : "DynamicPlace"}
          >
            <MenuItem value="StaticPlace" key="StaticPlace">Static Place</MenuItem>
            <MenuItem value="DynamicPlace" key="DynamicPlace">Dynamic Place</MenuItem>
          </Select>
      </Grid>
      <Grid item xs={2}>
          {
          getFieldDecorator('indexValue', { initialValue: (this.props.indexValue !== null? this.props.indexValue : ""), rules: [{ required: false }],})(
            <TextField id="indexValue" label="Index Value" color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }} placeholder="" />
          )
        }
      </Grid>

      <Grid item xs={3}>
      <InputLabel style={{ fontSize: 12,  marginTop: 14, marginBottom: 3 }}>Insertion</InputLabel>
      <Select fullWidth id="insertion"
            labelId="select-settings-insertion"
            onChange={this.handleChangeInsertion} 
            value={this.state.insertion === "After" ? "After" : "Before"}
          >
            <MenuItem value="After" key="After">After</MenuItem>
            <MenuItem value="Before" key="Before">Before</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={2}>
        {getFieldDecorator('adWidth', { initialValue: (this.props.adWidth || ''), rules: [{ required: true }],})(
          <TextField id="adWidth" label="Width" color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }} placeholder="" />
        )}
      </Grid>
      <Grid item xs={2}>
        {getFieldDecorator('adHeight', { initialValue: (this.props.adHeight || ''), rules: [{ required: true }],})(
          <TextField id="adHeight" label="Height" color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }} placeholder="" />
        )}
      </Grid>
      <Grid item xs={12}>
        {getFieldDecorator('divElementName', { initialValue: (this.props.divElementName || ''), rules: [{ required: true }],})(
          <TextField id="divElementName" label="Div Element Name / Query Selector" color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }} placeholder="" />
        )}
      </Grid>
      <Grid item xs={12}>
        {getFieldDecorator('customStyle', { initialValue: (this.props.customStyle || ''), rules: [{ required: false }],})(
          <TextField id="customStyle" label="Custom Style" color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }} placeholder="" />
        )}
      </Grid> 
      <Grid item xs={12}>
        {getFieldDecorator('imageSizesOverride', { initialValue: (this.props.imageSizesOverride || ''), rules: [{ required: false }],})(
          <TextField id="imageSizesOverride" label="Image Sizes Override (Desktop)" color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }} placeholder="" />
        )}
      </Grid>     
      <Grid item xs={4}>
        {getFieldDecorator('isMobile', { initialValue: (this.props.isMobile || ''), rules: [{ required: false }],})(
          <>
            <FormControlLabel
              control={
                <Checkbox id="isMobile"
                  checked={this.state.checkMobile}
                  value={this.state.checkMobile}
                  onChange = {this.handleChangeCheckBox}
                  inputProps={{
                    'aria-label': 'primary checkbox',
                  }}
                />
              }
              style={{marginTop : 10}}
              label="Is Mobile" />
            </>
        )}
      </Grid>    
      <Grid item xs={4}>
        {getFieldDecorator('showCloseButton', { initialValue: (this.props.showCloseButton || ''), rules: [{ required: false }],})(
          <>
            <FormControlLabel
              control={
                <Checkbox id="showCloseButton"
                  checked={this.state.showCloseButton}
                  value={this.state.showCloseButton}
                  onChange = {this.handleChangeShowCloseButton}
                  inputProps={{
                    'aria-label': 'primary checkbox',
                  }}
                />
              }
              style={{marginTop : 10}}
              label="Show close button" />
            </>
        )}
      </Grid>
      <Grid item xs={4}>
        {getFieldDecorator('isHeaderHide', { initialValue: (this.props.isHeaderHide || ''), rules: [{ required: false }],})(
          <>
            <FormControlLabel
              control={
                <Checkbox id="isHeaderHide"
                  checked={this.state.isHeaderHide}
                  value={this.state.isHeaderHide}
                  onChange = {this.handleChangeIsHeaderHide}
                  inputProps={{
                    'aria-label': 'primary checkbox',
                  }}
                />
              }
              style={{marginTop : 10}}
              label="Is Header Hide" />
            </>
        )}
      </Grid>    
      <Grid item xs={4}>
        {getFieldDecorator('isVideo', { initialValue: (this.props.isVideo || ''), rules: [{ required: false }],})(
          <>
            <FormControlLabel
              control={
                <Checkbox id="isVideo"
                  checked={this.state.isVideo}
                  value={this.state.isVideo}
                  onChange = {this.handleChangeIsVideo}
                  inputProps={{
                    'aria-label': 'primary checkbox',
                  }}
                />
              }
              style={{marginTop : 10}}
              label="Is Video" />
            </>
        )}
      </Grid>    
      <Grid item xs={4}>
        {getFieldDecorator('isFullImage', { initialValue: (this.props.isFullImage || ''), rules: [{ required: false }],})(
          <>
            <FormControlLabel
              control={
                <Checkbox id="isFullImage"
                  checked={this.state.isFullImage}
                  value={this.state.isFullImage}
                  onChange = {this.handleChangeIsFullImage}
                  inputProps={{
                    'aria-label': 'primary checkbox',
                  }}
                />
              }
              style={{marginTop : 10}}
              label="Is Full Image" />
            </>
        )}
      </Grid>    
      <Grid item xs={4}>
        {getFieldDecorator('isFullAnchor', { initialValue: (this.props.isFullAnchor || ''), rules: [{ required: false }],})(
          <>
            <FormControlLabel
              control={
                <Checkbox id="isFullAnchor"
                  checked={this.state.isFullAnchor}
                  value={this.state.isFullAnchor}
                  onChange = {this.handleChangeIsFullAnchor}
                  inputProps={{
                    'aria-label': 'primary checkbox',
                  }}
                />
              }
              style={{marginTop : 10}}
              label="Is Full Anchor" />
            </>
        )}
      </Grid>    

      </Grid>
      </form>
    );
  }
}

const LayoutDefinitionsForm = Form.create()(LayoutDefinitionForm);

export default LayoutDefinitionsForm